import { getFromSession, setSessionKey, eventUtil, addSubDirectoryPrefix, axiosWrapper } from '../../utils';
import { pageStoreComponentID } from '../../organisms/PageContext';
import { constants, CUSTOM_EVENTS_CONSTANTS } from '../../constants/common';

const {
  MOBILE_NUMBER,
  COUNTRY_CODE,
  REVISION_TOKEN,
  UPDATE_CUSTOMER_PROFILE,
  OTP_FLYOUT_TYPE,
  OTP_SUCCESS_EVENT,
  SIGNIN_MODAL_OPEN_EVENT,
  SIGNIN_TYPE_QRV,
  PHONE_PRIORITY,
  CONTENT_TYPE_KEY,
  CONTENT_TYPE_VALUE,
  SUCCESS,
  SAVE_PHONE_TO_PROFILE_SESSION_KEY,
  ENCRYPT_DATA,
  error,
} = constants;

export { SAVE_PHONE_TO_PROFILE_SESSION_KEY };

export const handleCloseModal = (
  updateComponentState: (data: { componentName: string; newState: Record<string, unknown> }) => void
) => {
  eventUtil.dispatch(CUSTOM_EVENTS_CONSTANTS.CLOSE_DRAWER, {});
  updateComponentState({
    componentName: pageStoreComponentID.PHONE_NUMBER_SAVE_TO_PROFILE,
    newState: { isOTPVerificationSuccess: true },
  });
};

export const triggerOtpFlyout = (
  updateComponentState: (data: { componentName: string; newState: Record<string, unknown> }) => void
) => {
  eventUtil.dispatch(SIGNIN_MODAL_OPEN_EVENT, {
    modalType: SIGNIN_TYPE_QRV,
    isFlyOut: true,
    newApproach: true,
    isBookFlow: true,
    flyoutType: OTP_FLYOUT_TYPE,
    successEvent: OTP_SUCCESS_EVENT,
  });
  eventUtil.on(OTP_SUCCESS_EVENT, () => handleCloseModal(updateComponentState));
};

export const updatePhoneProfile = async (
  updateComponentState: (data: { componentName: string; newState: Record<string, unknown> }) => void
) => {
  const phoneNumber = getFromSession(MOBILE_NUMBER);
  const countryCode = getFromSession(COUNTRY_CODE);
  const revisionToken = getFromSession(REVISION_TOKEN);

  try {
    const payload = {
      phones: [
        {
          countryCode,
          phoneNumber,
          phoneType: PHONE_PRIORITY[0], // 'MT'
        },
      ],
      updateProfileType: ['phones'],
      revisionToken,
    };

    const url = addSubDirectoryPrefix(UPDATE_CUSTOMER_PROFILE);
    const response = await axiosWrapper
      .post(url, payload, {
        headers: {
          [CONTENT_TYPE_KEY]: CONTENT_TYPE_VALUE,
        },
      })
      .then(res => res.data);

    if (response?.status?.toLowerCase() === SUCCESS && response?.encodePayload) {
      setSessionKey(ENCRYPT_DATA, response.encodePayload);
      triggerOtpFlyout(updateComponentState);
    } else {
      updateComponentState({
        componentName: pageStoreComponentID.PAGE_ERRORS,
        newState: {
          errors: [
            {
              message: 'Unable to update phone number. Please try again.',
              type: error,
            },
          ],
        },
      });
    }
  } catch (err) {
    console.error('Failed to trigger OTP flow', err);
  }
};
